export default __webpack_public_path__ + "static/media/hult-buet.2ac77309.png";